import { TOGGLE_LEFT_DRAWER_EVENT } from '../ThemeBase';
import { FocusTrap } from '../utils';

export default class MobileMenu {
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;
    this.isOpen = false;
    this.focusTrap = null;

    document.documentElement.addEventListener(TOGGLE_LEFT_DRAWER_EVENT, this.handleToggle);

    const toggleButtons = document.querySelectorAll('.mobile-nav__toggle');
    toggleButtons.forEach(button => {
      button.addEventListener('click', function(evt) {
        evt.currentTarget.parentElement.classList.toggle('mobile-nav--expanded');
      });
    });

    this.element.querySelector('.mobile-menu--close-btn').addEventListener('click', (e) => { 
      e.preventDefault(); 
      this.close(); 
    });
  }

  handleToggle = (e) => {
    this.toggle(e.detail.forceOpen);
  }

  close = () => {
    document.body.classList.remove('js-drawer-open');
    document.body.classList.remove('js-drawer-open-left');
    this.isOpen = false;

    if (this.focusTrap) {
      this.focusTrap.destroy();
      this.focusTrap = null;
    }
  }

  open = () => {
    document.body.classList.add('js-drawer-open');
    document.body.classList.add('js-drawer-open-left');
    this.isOpen = true;

    const container = document.querySelector('#NavDrawer');
    this.focusTrap = new FocusTrap(container);
  }

  toggle = (forceOpen = undefined) => {
    if (forceOpen === true) {
      this.open();
    } else if (forceOpen === false) {
      this.close();
    } else if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
}
